export const REPORTING_TEMPLATE_PAGE = 'reporting-template-library';

export const MAX_TEMPLATE_NAME_LENGTH_LIMIT = 255;
export const MAX_TEMPLATE_DESCRIPTION_LENGTH_LIMIT = 1000;
export const TEMPLATE_FORM_STORAGE_KEY = 'templateFormData';
